import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Empty, Image, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import default_bank from '../../../../../Assets/ic_default_bank.png';
import LinkedDelinkedAccountResponse from '../../../../../Models/Response/Account/LinkedDelinkedAccounts';
import GetConsentByHandleResponse from '../../../../../Models/Response/Consent/GetConsentByHandle';
import { getConsentByConsentHandle } from '../../../../../Services/ConsentServices/ConsentService';
import { encode } from '../../../../../Services/RedirectionServices/Redirection';
import { logoBaseUrl } from '../../../../../Utils/Constants/baseUrl';
import { QueryParams, Routes } from '../../../../../Utils/Constants/routes';
import CommonConsentDetails from '../../CommonConsentDetails';

import '../index.css';

interface IPendingConsentProps {
  consentUniqueId: string;
  type: string;
  cardClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  selectedCard: string[];
  approvalConsent: (type: string) => void;
  isLinkAccountLoading: boolean;
  linkedAccounts: LinkedDelinkedAccountResponse;
  createdOrUpdatedOn: string;
}

const PendingConsent: React.FC<IPendingConsentProps> = ({
  cardClick,
  selectedCard,
  approvalConsent,
  isLinkAccountLoading,
  linkedAccounts,
  consentUniqueId,
  createdOrUpdatedOn,
  type,
}) => {
  const history = useHistory();
  const [consentDetailsByHandle, setConsentDetailsByHandle] = useState({
    Customer: { id: '' },
    DataConsumer: { dataConsumerType: '', id: '' },
    DataFilter: [{ type: '', operator: '', value: '' }],
    DataLife: { unit: '', value: 0 },
    FIDataRange: { from: '', to: '' },
    Frequency: { unit: '', value: 0 },
    Purpose: { category: { type: '' }, code: '', refUri: '', text: '' },
    consentExpiry: '',
    consentMode: '',
    consentStart: '',
    consentTypes: [''],
    fetchType: '',
    fiTypes: [''],
  });
  const { t } = useTranslation();

  useEffect(() => {
    getConsentByConsentHandle(consentUniqueId)
      .then((res) => res.data)
      .then((res: GetConsentByHandleResponse) => setConsentDetailsByHandle(res))
      .catch(() => {
        if (
          !!localStorage.getItem('redirect') &&
          !!localStorage.getItem('txnid') &&
          !!localStorage.getItem('sessionid')
        ) {
          const encodeParam = {
            txnid: localStorage.getItem('txnid') || '',
            sessionid: localStorage.getItem('sessionid') || '',
            srcref: localStorage.getItem('srcref') || '',
            status: 'F',
            errorcode: '2',
            userid: localStorage.getItem('userid') || '',
          };

          encode(encodeParam).then((res) => {
            window.location.replace(
              `${localStorage.getItem('redirect')}?fi=${res.data.fi}&resdate=${
                res.data.resdate
              }&ecres=${res.data.ecres}`
            );
            localStorage.clear();
          });
        }
        history.replace(Routes.consent);
      });
  }, [consentUniqueId, history]);

  const linkAccountsRedirect = () => {
    history.push({
      pathname: Routes.linkAccounts,
      search: `?${QueryParams.redirect}=${history.location.pathname}`,
    });
  };

  const { Text } = Typography;
  return (
    <>
      <CommonConsentDetails
        createdOrUpdatedOn={createdOrUpdatedOn}
        type={type}
        consentByUniqueIdDetails={consentDetailsByHandle}
      >
        <div className='consentDetailsAccounts'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Text className='typoText'>
              {t('Select your account for sharing information')}
            </Text>
            <Button
              type='link'
              // id="linkAccount"
              className='pendingConsentAddAccount'
              onClick={linkAccountsRedirect}
            >
              <PlusOutlined /> {t('Add Accounts')}
            </Button>
          </div>
          <div className='linkedAccountsDiv'>
            {linkedAccounts && linkedAccounts.length ? (
              linkedAccounts.map((accounts, index) => (
                <Card
                  key={index}
                  className='accountCard activeAccountCard'
                  id={index.toString()}
                  hoverable={true}
                  onClick={cardClick}
                >
                  <Image
                    className='fipLogo'
                    src={logoBaseUrl + accounts.fipHandle + '.png'}
                    fallback={default_bank}
                    preview={false}
                  />
                  <div className='accountInfo'>
                    <Text className='type'>FipName : </Text>
                    <Text className='value' type='secondary'>
                      {accounts.fipName}
                    </Text>
                    <br />
                    <Text className='type'>MaskedAccNumber : </Text>
                    <Text className='value' type='secondary'>
                      {accounts.maskedAccNumber}
                    </Text>
                  </div>

                  <Checkbox
                    checked={
                      selectedCard.indexOf(index.toString()) === -1
                        ? false
                        : true
                    }
                    className='accountsCardCheckBox'
                  />
                </Card>
              ))
            ) : (
              <Empty
                description={
                  <Typography.Text className='noAccountFound'>
                    {t('No')} {t('Linked Accounts')}
                  </Typography.Text>
                }
              />
            )}
          </div>
        </div>
      </CommonConsentDetails>

      <div className='activeButtonGroup'>
        <Button
          loading={isLinkAccountLoading}
          disabled={isLinkAccountLoading || selectedCard.length === 0}
          id='linkAccount'
          className='primaryButton'
          // tslint:disable-next-line: jsx-no-lambda
          onClick={() => approvalConsent('READY')}
        >
          {t('APPROVE')}
        </Button>

        <Button
          loading={isLinkAccountLoading}
          id='linkAccount'
          className='primaryButton'
          // tslint:disable-next-line: jsx-no-lambda
          onClick={() => approvalConsent('FAILED')}
        >
          {t('REJECT')}
        </Button>
      </div>
    </>
  );
};

export default PendingConsent;
